<div class="settings">
    @if (!moreOptions.directComponentRender) {
    <div class="header">
        <div class="tab">
            <button (click)="currentTab = 'grid'" [class]="(currentTab === 'grid'  ? 'active ': '') + 'tablinks'">
                <i class="fa fa-grid"></i>
                <span>Grid</span>
            </button>
            <!-- <button (click)="currentTab = 'schedular'"
                [class]="(currentTab === 'schedular'  ? 'active ': '') + 'tablinks'">
                <i class="fa fa-calendar-lines-pen"></i>
                <span>Scheduler</span>
            </button> -->
            <button (click)="currentTab = 'export'" *ngIf="showExport"
                [class]="(currentTab === 'export'  ? 'active ': '') + 'tablinks'">
                <i class="fa fa-file-export"></i>
                <span>Export</span>
            </button>
        </div>
        <a class="close" (click)="onClose($event)"><i class="fa-regular fa-times"></i></a>
    </div>
    }
    <div class="tabcontent">
        @if (currentTab === 'grid') {
        @if (!moreOptions.directComponentRender) {
        <div class="horizontal-options">
            <div>
                <label>{{moreOptions.label || 'Layout'}}</label>
            </div>
    
            <div class="horizontal-options-icons">
                <div class="action__item" (click)="onModeChange(GridMode.Grid)"><a
                        [ngClass]="{ 'active' : tableService.gridMode == GridMode.Grid }" class="link-icon"><i
                            class="fa-thin fa-grid-2"></i></a></div>
                <!-- <div class="action__item" (click)="onModeChange(GridMode.List)"> <a
                        [ngClass]="{ 'active' : tableService.gridMode == GridMode.List }" class="link-icon"><i
                            class="fa-thin fa-list"></i></a>
                </div> -->
                <div class="action__item" *ngIf="showCardView" (click)="onModeChange(GridMode.Card)"> <a
                        [ngClass]="{ 'active' : tableService.gridMode == GridMode.Card }" class="link-icon"><i
                            class="fa-thin fa-users"></i></a>
                </div>
            </div>
            <!-- <div class="action__item" style="margin-top: 8px;">
                                            <div class="dropdown-list action__item">
                                                <f-dropdown id="ft" [style]="{ minWidth: '100%' }" (ngModelChange)="onModeChange($event)" [(ngModel)]="tableService.gridMode" [options]="gridOptions"
                                                    placeholder="Select a type" optionLabel="name" optionValue="value">
                                                    <ng-template let-item pTemplate="item">
                                                        <div class="flex align-items-center gap-2">
                                                            <div>{{ item.name }}</div>
                                                        </div>
                                                    </ng-template>
                                                </f-dropdown>
                                            </div>
                                        </div> -->
        </div>
        }
        <div class="flex-align-vc justify-content-space-between">
            <label for="ft" class="schedular-label">Column Setting</label>
            @if (moreOptions.directComponentRender || moreOptions.saveConfig) {
            <div class="horizontal-options-icons"> 
                <div class="action__item" [attr.data-tooltip]="'Save'" data-tooltip-conf="left" (click)="onSave($event)"><a
                        class="link-icon"><i class="fa-light fa-save"></i></a></div>
                <div *ngIf="moreOptions.directComponentRender" class="action__item" (click)="onModeChange(GridMode.List)"
                    (click)="onClose($event)"> <a class="link-icon"><i class="fa-light fa-times"></i></a>
                </div>
            </div>
    
            }
        </div>
        @if (hasChanges) {
        <p class="red">changes not saved</p>
        }
        <div cdkDropListGroup class="columns">
            <div class="freez-columns" *ngIf="moreOptions.showFrozenOption">
                <h5>Freezed Columns</h5>
                <ul class="column-setting column-list" id="freeze" [cdkDropListData]="freeze" cdkDropList
                    (cdkDropListDropped)="drop($event)">
                    @for (column of freeze; track column; let i = $index) {
                    @if (column.name) {
                    <li cdkDrag class="column-box freezed" [cdkDragData]="column">
                        <div class="column-custom-placeholder" *cdkDragPlaceholder></div>
                        <div class="setting__content">
                            <span><i class="fa-regular fa-grip-dots-vertical"></i></span>
                            <div class="checkbox-container checkbox__content checkbox__content--no-margin">
                                <input (ngModelChange)="onChange(column, $event)" [checked]="column.viewable"
                                    [(ngModel)]="column.viewable" type="checkbox" name="checkboxMobile"  [disabled]="freeze[i].viewable">
                                <span class="checkmark"></span>
                            </div>
                            <span>{{ column.name }}</span>
                        </div>
                    </li>
                    }
                    }
                </ul>
            </div>
    
            <ul class="column-setting column-list" id="unfreeze" [cdkDropListData]="unfreeze" cdkDropList
                (cdkDropListDropped)="drop($event)">
                @for (column of unfreeze; track column) {
                @if (column.name) {
                <li cdkDrag class="column-box unfreezed" [cdkDragDisabled]="column.frozen" [cdkDragData]="column">
                    <div class="column-custom-placeholder" *cdkDragPlaceholder></div>
                    <div class="setting__content">
                        <span><i class="fa-regular fa-grip-dots-vertical"></i></span>
                        <div class="checkbox-container checkbox__content checkbox__content--no-margin">
                            <input (ngModelChange)="onChange(column, $event)" [checked]="column.viewable ? 'checked' : ''"
                                [(ngModel)]="column.viewable" type="checkbox" name="checkboxMobile">
                            <span (click)="!column.viewable" class="checkmark"></span>
                        </div>
                        <span>{{ column.name }}</span>
                    </div>
                </li>
                }
                }
            </ul>
        </div>
        } @else if (currentTab === 'schedular') {
        <cx-schedular [views]="views" [module]="module">
        </cx-schedular>
        } @else if (currentTab === 'export') {
        <cx-export-modal (export)="onExport($event)"></cx-export-modal>
        }
    </div>
</div>